import { AddShopCart, GetShopCart, RemoveShopCart } from "@/api/shopcart";
import { getLocalStorage } from "@/common/cookie";
import { post } from "@/common/request.js";

// 確認購物車中有無符合的商品，返回排序編號
const GetShopCartItemIndex = (state, { product, options }) => {
  // 確認商品是否存在購物車
  let index = -1;

  // 客製化商品不堆疊，直接返回-1
  if (product.IsCustom == "Y") {
    return index;
  }

  // 檢查目前購物車中是否有商品ID與選項都符合的項目
  state.shopcart.forEach((item, item_index) => {
    if (item.goodsID == product.GoodsID) {
      if (
        item.active_option[0] === options[0] &&
        item.active_option[1] === options[1]
      ) {
        index = item_index;
      }
    }
  });
  return index;
};

const GetCurrentStock = ({ product, options }) => {
  if (product.IsCustom == "Y") {
    let stock = product.CustomGoodsStock;
    let spec_list = [];
    options.forEach((option_id) => {
      const spec = product.CustomSpecList.find((item) => {
        return item.CustomSpecID == option_id;
      });

      spec_list.push({
        SpecTitle: spec.SpecTitle,
        SpecCategoryTitle: spec.SpecCategoryTitle,
      });
    });
    stock.SpecList = spec_list;
    return stock;
  } else {
    return product.Stock.find((item) => {
      return item.ColorID == options[0] && item.SizeID == options[1];
    });
  }
};

const GetCurrentImage = ({ product, options }) => {
  if (product.IsCustom == "Y") {
    return product.Image1;
  } else {
    const fullmatchImage = product.Picture.find((item) => {
      return item.ColorID == options[0] && item.SizeID == options[1];
    });
    const sizematchImage = product.Picture.find((item) => {
      return item.SizeID == options[1];
    });
    const colormatchImage = product.Picture.find((item) => {
      return item.ColorID == options[0];
    });

    if (fullmatchImage) {
      return fullmatchImage.Image;
    } else if (sizematchImage) {
      return sizematchImage.Image;
    } else if (colormatchImage) {
      return colormatchImage.Image;
    } else {
      return product.Image1;
    }
  }
};

// 檢查商品是否在販售期間

const shopcart_module = {
  namespaced: true,
  state: () => ({
    shopcart: [], //購物車
    product_data: null, //商品資料
    add_cart_message: 0, //購物車訊息顯示
  }),
  actions: {
    // 會員加入購物車
    async AddShopCart(
      { state, dispatch, commit },
      { product, options, amount, show_message = false, order_memo = "" }
    ) {
      let shop_cart_item = {
        GoodsID: product.GoodsID,
        EventMemo: order_memo,
      };
      // 一般商品，帶入ColorID與SizeID
      if (product.IsCustom == "N") {
        shop_cart_item.ColorID = options[0];
        shop_cart_item.SizeID = options[1];
      }
      // 客製化商品，將CustomSpecID轉為字串帶入
      else {
        shop_cart_item.CustomSpecID = options.join();
      }

      //檢查商品是否有設定限購數量，有的話則檢查目前購物車相同商品數量
      if (product.PurchaseLimit != 0) {
        let current_amount = 0;
        state.shopcart.forEach((item) => {
          if (item.GoodsID == product.GoodsID) {
            current_amount += item.amount;
          }
        });
        if (current_amount + parseInt(amount) > product.PurchaseLimit) {
          alert(
            `此商品每人限購${product.PurchaseLimit}件，您目前已選購${current_amount}件`
          );
          return;
        }
      }

      const add_result = await AddShopCart(shop_cart_item, amount);
      if (add_result.code == 302) {
        // token 過期，先清空購物車再新增至本地購物車
        commit("SetShopCart", []);
        commit("AddShopCart", {
          product: product,
          options: options,
          amount: amount,
          order_memo: order_memo,
        });
      } else if (add_result.code != 200) {
        alert(add_result.msg);
      } else {
        // call 取得購物車 api，更新購物車狀態，並依情況顯示加入購物車訊息
        show_message ? commit("SetAddCartMessage", 1) : "";
        if (add_result.data.Message != "") {
          // 呼叫 store 的 SetDialog 方法，顯示系統訊息
          commit(
            "SetDialog",
            { status: true, content: add_result.data.Message },
            { root: true }
          );
        }
        commit("SetProductData", add_result.data.Products.List);
        dispatch("ConvertShopCart", add_result.data.List);
      }

      return new Promise((resolve) => {
        resolve();
      });
    },
    // 會員移除購物車商品
    async RemoveShopCart({ state, dispatch, commit }, { index, amount }) {
      let remove_list = [];
      // 若數量為-1表示移除全部數量
      if (amount == -1) {
        remove_list = state.shopcart[index].shopcart_id;
      }
      // 除此之外放入該商品指定數量的ShopCartID
      else {
        for (let i = 0; i < amount; i++) {
          remove_list.push(state.shopcart[index].shopcart_id[i]);
        }
      }
      // remove_list不為空時才執行
      if (remove_list.length > 0) {
        const remove_result = await RemoveShopCart(remove_list);
        if (remove_result.code == 302) {
          // token 過期，清空購物車
          commit("SetShopCart", []);
        } else {
          // 重新取得目前購物車狀態
          // 將API的購物車資訊轉換格式
          if (remove_result.data.Message != "") {
            // 呼叫 store 的 SetDialog 方法，顯示系統訊息
            commit(
              "SetDialog",
              { status: true, content: remove_result.data.Message },
              { root: true }
            );
          }
          commit("SetProductData", remove_result.data.Products.List);
          dispatch("ConvertShopCart", remove_result.data.List);
        }
      }

      return new Promise((resolve) => {
        resolve();
      });
    },
    // 取得會員購物車
    async GetShopCart({ commit, dispatch }) {
      // 檢查是否有會員token，若無則改為讀取本地ShopCart
      if (getLocalStorage("account_token")) {
        GetShopCart().then(async (res) => {
          if (res.code != 302) {
            // 將API的購物車資訊轉換格式
            if (res.data.Message != "") {
              // 呼叫 store 的 SetDialog 方法，顯示系統訊息
              commit(
                "SetDialog",
                { status: true, content: res.data.Message },
                { root: true }
              );
            }
            commit("SetProductData", res.data.Products.List);
            dispatch("ConvertShopCart", res.data.List);
          }
        });
      }
    },
    // API購物車格式轉換
    async ConvertShopCart({ commit, state }, shopcart) {
      commit("SetShopCart", []);
      shopcart.forEach((item) => {
        // 檢查商品是否存在
        const product = state.product_data.find(
          (prod) => prod.GoodsID == item.GoodsID
        );
        let options = [];
        if (product.IsCustom == "Y") {
          options = item.CustomSpecID.split(",");
        } else {
          options = [item.ColorID, item.SizeID];
        }
        commit("AddShopCart", {
          product,
          options,
          amount: 1,
          show_message: false,
          order_memo: item.EventMemo,
          shopcart_id: item.ShoppingCartID,
        });
      });
    },
    async MixShopcart({ state, dispatch, commit }) {
      if (state.shopcart.length <= 0) {
        dispatch("GetShopCart");
        return;
      }

      // 依序將shopcart中的商品新增至會員線上購物車
      let tmp_shopcart = [];
      state.shopcart.forEach((item) => {
        for (let i = 0; i < item.amount; i++) {
          tmp_shopcart.push({
            GoodsID: item.goodsID,
            ColorID: item.is_custom == "N" ? item.active_option[0] : "-1",
            SizeID: item.is_custom == "N" ? item.active_option[1] : "-1",
            CustomSpecID:
              item.is_custom == "Y" ? item.active_option.join() : "-1",
            EventMemo: item.order_memo,
          });
        }
      });
      const res = await post("member/shoppingCart", {
        ShopcartData: tmp_shopcart,
      });

      if (res.code != 302) {
        // 將API的購物車資訊轉換格式
        if (res.data.Message != "") {
          // 呼叫 store 的 SetDialog 方法，顯示系統訊息
          commit(
            "SetDialog",
            { status: true, content: res.data.Message },
            { root: true }
          );
        }
        commit("SetProductData", res.data.Products.List);
        dispatch("ConvertShopCart", res.data.List);
      }
    },
        // 檢查購物車種是否有冷凍商品或常溫商品
    CheckShopCartTempType({state}, temp_type) {
      if(state.shopcart.length==0){
        return false
      }
      let has_type = false;
      state.shopcart.forEach((item) => {
        if (temp_type == "frozen" && item.is_frozen) {
          has_type = true;
        } else if (temp_type == "normal" && !item.is_frozen) {
          has_type = true;
        }
      });
      return has_type;
    },
  },
  mutations: {
    // 檢查購物車中的商品格式
    CheckShopCartFormat(state) {
      state.shopcart.forEach((item) => {
        if(item.is_frozen==undefined || item.type ==undefined){
          // remove product
          state.shopcart.splice(state.shopcart.indexOf(item), 1);
        }
      });
    },
    // 檢查購物車加購商品數量
    CheckShopCartAddOnAmount(state) {
      let count = 0;
      state.shopcart.forEach((item) => {
        if(item.type == "add-on"){
          count+=1;
        }
      });
      if(count >= state.shopcart.length){
        state.shopcart = [];
      }
    },
    // 非會員加入購物車
    AddShopCart(
      state,
      {
        product,
        options,
        amount,
        show_message = false,
        order_memo = "",
        shopcart_id = "",
      }
    ) {
      //檢查商品是否有設定限購數量，有的話則檢查目前購物車相同商品數量
      if (product.PurchaseLimit != 0) {
        let current_amount = 0;
        state.shopcart.forEach((item) => {
          if (item.goodsID == product.GoodsID) {
            current_amount += item.amount;
          }
        });
        if (current_amount + parseInt(amount) > product.PurchaseLimit) {
          alert(
            `此商品每人限購${product.PurchaseLimit}件，您目前已選購${current_amount}件`
          );
          return;
        }
      }

      // 搜尋購物車中相同商品的位置，若無相同商品則返回-1
      const product_index = GetShopCartItemIndex(state, {
        product: product,
        options: options,
      });

      if (product_index == -1) {
        // 若商品不存在則新增
        const shopcart_item = {
          goodsID: product.GoodsID,
          stock: GetCurrentStock({ product: product, options: options }),
          image: GetCurrentImage({ product: product, options: options }),
          title: product.Title,
          option_name_1: product.Option1,
          option_name_2: product.Option2,
          active_option: options,
          is_custom: product.IsCustom,
          amount: parseInt(amount),
          shopcart_id: shopcart_id == "" ? [] : [shopcart_id],
          order_memo: order_memo,
          is_frozen: product.DeliveryFrozen == "Y" ? true : false,
          type: product.Type,
        };
        state.shopcart.push(shopcart_item);
      } else {
        // 若商品存在則增加數量
        state.shopcart[product_index].amount += parseInt(amount);
        // 若有shopcart_id則加入陣列中
        shopcart_id != ""
          ? state.shopcart[product_index].shopcart_id.push(shopcart_id)
          : "";
      }
      // 依情況顯示加入購物車訊息
      show_message ? (state.add_cart_message += 1) : "";
    },
    // 非會員移除購物車商品
    RemoveShopCart(state, { index, amount }) {
      if (amount == -1) {
        // 若數量為-1則直接將該商品移除
        state.shopcart.splice(index, 1);
      } else {
        // 若數量不為-1則扣除指定的數量
        state.shopcart[index].amount =
          parseInt(state.shopcart[index].amount) - parseInt(amount);
        // 若扣除數量後商品數量小於等於0，則移除該商品
        state.shopcart[index].amount <= 0
          ? state.shopcart.splice(index, 1)
          : "";
      }
    },
    // 設定購物車資料
    SetShopCart(state, shopcart) {
      state.shopcart = shopcart;
    },
    // 設定商品資料
    SetProductData(state, product_data) {
      if (state.product_data != null) {
        //合併已有資料
        state.product_data = state.product_data.concat(product_data);
        //去除重複資料
        state.product_data = Array.from(new Set(state.product_data));
      } else {
        state.product_data = product_data;
      }
    },
    // 設定購物車訊息顯示
    SetAddCartMessage(state, action) {
      const next_num = state.add_cart_message + action;
      next_num <= 0
        ? (state.add_cart_message = 0)
        : (state.add_cart_message = next_num);
    },
  },
};

export { shopcart_module };
